import { render, staticRenderFns } from "./ViewTicketRaised.vue?vue&type=template&id=20c639fa&"
import script from "./ViewTicketRaised.vue?vue&type=script&lang=js&"
export * from "./ViewTicketRaised.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports